export const goldStarImg = '/images/interface/star.svg'
export const noBgStarImg = '/images/interface/star-gray-large.svg'
export const noBgStarImgBig = '/images/interface/star-gray-large.png'
export const primaryStarSVG = '/images/interface/star-bg.svg'
export const primaryStarLargeSVG = '/images/interface/star-bg-large.svg'
export const grayStarLarge = '/images/interface/star-gray-large.svg'
export const primaryInfoSignSVG = '/images/interface/Info.svg'
export const copyTextSVG = '/images/interface/copy-text.svg'
